<template>
  <div :class="'btn-group drop' + direction + ' ' + containerClass" ref="dropdownContainer">
    <button 
      type="button" 
      class="btn" 
      :class="buttonClass"
      aria-haspopup="true" 
      :aria-expanded="isOpen" 
      @click.stop="toggleDropdown"
      :disabled="buttonDisabled ? true : undefined"
    >
      <slot name="trigger"></slot>
    </button>
    <Teleport to="body" v-if="teleport">
      <ul 
        v-if="isOpen" 
        class="dropdown-menu" 
        ref="teleportMenu"
        :class="menuClass"
        :style="teleportMenuStyle"
        @click="handleMenuClick"
      >
        <slot></slot>
      </ul>
    </Teleport>
    <ul 
      v-else-if="isOpen" 
      class="dropdown-menu" 
      :class="menuClass"
      style="display: block"
      @click="handleMenuClick"
    >
      <slot></slot>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    buttonClass: {
      type: String,
      default: 'btn-default'
    },
    containerClass: {
      type: String,
      default: ''
    },
    buttonDisabled: {
      type: Boolean,
      default: false
    },
    menuClass: {
      type: String,
      default: ''
    },
    direction: {
      type: String,
      default: 'down'
    },
    teleport: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      menuPosition: {}
    }
  },
  computed: {
    teleportMenuStyle() {
      return {
        display: 'block',
        position: 'fixed',
        zIndex: 9999,
        ...this.menuPosition
      }
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen
      if (this.isOpen && this.teleport) {
        this.$nextTick(() => {
          this.updateTeleportMenuPosition()
        })
      }
    },
    updateTeleportMenuPosition () {
      const container = this.$refs.dropdownContainer
      if (!container) {
        return
      }
      const rect = container.getBoundingClientRect()
      const isRightAligned = this.menuClass && this.menuClass.includes('dropdown-menu-right')
      const menuHeight = this.$refs.teleportMenu ? this.$refs.teleportMenu.offsetHeight : 0
      const spaceBelow = window.innerHeight - rect.bottom
      const openUp = menuHeight > 0 && spaceBelow < menuHeight && rect.top > spaceBelow
      const horizontal = isRightAligned
        ? { right: (window.innerWidth - rect.right) + 'px', left: 'auto' }
        : { left: rect.left + 'px', right: 'auto' }
      this.menuPosition = openUp
        ? { top: 'auto', bottom: (window.innerHeight - rect.top) + 'px', ...horizontal }
        : { top: rect.bottom + 'px', bottom: 'auto', ...horizontal }
    },
    handleClickOutside(event) {
      const inTrigger = this.$refs.dropdownContainer && this.$refs.dropdownContainer.contains(event.target)
      const inMenu = this.$refs.teleportMenu && this.$refs.teleportMenu.contains(event.target)
      if (!inTrigger && !inMenu) {
        this.isOpen = false
      }
    },
    handleMenuClick() {
      this.isOpen = false
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>